import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/opt/buildhome/repo/components/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/opt/buildhome/repo/node_modules/next/dist/client/app-dir/link.js");
